import React from "react";
import { useSelector } from "react-redux";
import { TranslationText } from "components/TextTranslationContainer";
import { PriceRender } from "components/DisplayPrice";

const LoyaltyRedeemSwitch = ({
  switchLoyaltyStatus,
  redeemAmount,
  wrapperStyleProps = {},
  labelStyleProps = {},
  switchStyleProps = {},
  thumbStyleProps = {},
  textStyleProps = {},
}) => {
  const loyaltyApplied = useSelector(
    (state) => state?.Loyalty?.loyaltyApplied
  );

  if (Number(redeemAmount) <= 0) return null;

  return (
    <div
      className={`flex items-center ${
        wrapperStyleProps?.className || "rounded-lg bg-gray-100  mx-4 py-3 px-2"
      }`}
      style={wrapperStyleProps?.style}
    >
      <label
        className={`flex items-center cursor-pointer ${
          labelStyleProps?.className || ""
        }`}
        style={labelStyleProps?.style}
      >
        <div className="relative">
          <input
            type="checkbox"
            className="sr-only"
            checked={!!loyaltyApplied}
            onChange={switchLoyaltyStatus}
          />
          <div
            className={`w-12 h-6 rounded-full transition-colors ${
              loyaltyApplied ? "bg-brand-base-primary" : "bg-gray-300"
            } ${switchStyleProps?.className || ""}`}
            style={switchStyleProps?.style}
          />
          <div
            className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${
              loyaltyApplied ? "right-1" : "left-1"
            } ${thumbStyleProps?.className || ""}`}
            style={thumbStyleProps?.style}
          />
        </div>
      </label>
      <div
        className={
          textStyleProps?.className || "flex gap-1 flex-wrap text-[15px] text-black"
        }
        style={textStyleProps?.style}
      >
        <TranslationText text={"Use your loyalty balance to get"} />
        <PriceRender price={redeemAmount} className="text-brand-base-primary" />
        <TranslationText text={"off"} />
      </div>
    </div>
  );
};

export default LoyaltyRedeemSwitch;
